module.exports = vendor_c99105742d1b379cd37d;


//////////////////
// WEBPACK FOOTER
// external "vendor_c99105742d1b379cd37d"
// module id = 2
// module chunks = 0